module.exports = __webpack_public_path__ + "static/media/fan_room.f64c523a.jpeg";